export default __webpack_public_path__ + "assets/images/562759acfaa68fe95d7858535e0473b9.png";